export const customerSettings = {
COMPANY_CODE: "ad-garage-be",
ENV: "production",
VERSION: 1.1,
DOMAIN: 'usedcars.ad-garage.be',
SCRIPTS: [],
FONTS: [],
SENTRY_DSN: "",
LANGUAGES: ['nl', 'fr'],
FORCE_SINGLE_LANGUAGE_IN_URL: false,
WEBSITE_NAME: "",
IMAGE_PROMO_POSITION: "",
PATH_PREFIX: "",

GOOGLE_ANALYTICS_IDENTIFICATION: '',
GOOGLE_ANALYTICS_ID: '',
GOOGLE_TAG_MANAGER_ID: 'GTM-MBG6V873',
MAPBOX_TOKEN: 'pk.eyJ1IjoiYXV0cmFsaXMiLCJhIjoiY2toeXR2emhwMDk0OTJ6cWh0Y3JjeG5kaSJ9.YCvAWa5Wyqof0wPdueve5w',
RECAPTCHA_KEY: '6LcZyaUZAAAAAOrMBxDUfdVDq2xKcHORceibmov3',
FINANCING: false,
FINANCING_SETTINGA: 'Example',
FINANCING_TEXT: false,
RESERVATION: false,
FAVORITES: false,
VEHICLE_COMPARE: false,
SEO: false,
ACCOUNT: false
};